export const MULTI_TABS_TYPES = {
    DOC: 'doc',
    REQUEST_SIGNATURE: 'request-signature',
    DOCUMENT_STATUS: 'document-status' 
}
